import React from "react";
import axios from "axios";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";
import { API } from "../App";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    this.setState({ errorInfo });
    // Report to backend (best-effort, no throw on failure)
    try {
      axios.post(`${API}/client-error`, {
        message: String(error?.message || error),
        stack: String(error?.stack || ""),
        componentStack: String(errorInfo?.componentStack || ""),
        url: typeof window !== "undefined" ? window.location.href : "",
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      }, { withCredentials: true }).catch(() => {});
    } catch { /* no-op */ }
  }

  render() {
    if (this.state.hasError) {
      const isDev = process.env.NODE_ENV === "development";
      const errorMsg = this.state.error?.message || String(this.state.error || "");
      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-background">
          <Card className="max-w-md w-full">
            <CardContent className="pt-6 text-center space-y-4">
              <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto" />
              <h2 className="text-lg font-semibold">Une erreur est survenue</h2>
              <p className="text-sm text-muted-foreground">
                L&apos;application a rencontre un probleme. Veuillez rafraichir la page.
              </p>
              {isDev && errorMsg && (
                <details className="text-xs text-left bg-muted p-2 rounded max-h-40 overflow-auto">
                  <summary className="cursor-pointer font-medium">Détails techniques</summary>
                  <pre className="whitespace-pre-wrap mt-2">{errorMsg}
{this.state.errorInfo?.componentStack}</pre>
                </details>
              )}
              <div className="flex gap-2 justify-center">
                <Button onClick={() => window.location.reload()} data-testid="error-reload-btn">
                  Rafraichir la page
                </Button>
                <Button variant="outline" onClick={() => { this.setState({ hasError: false, error: null, errorInfo: null }); window.location.href = "/patient"; }}>
                  Retour au tableau de bord
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
